<body class="text-center">
  <div class="container">
    <img src="assets/images/pyxisOpenSpace.png" alt="OpenSpace_Image" />
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="card card-container">
              <button id="microsoft-signin-button" class="btn btn-primary btn-block btn-openlogin" (click)="login()">
                Iniciar sesión
              </button>
        </div>
      </div>
    </div>
  </div>
</body>